import { Module } from "vuex";
import { RootState } from "@/store/RootState";
import { mutations } from "@/components/overlay/store/mutations";
import { getters } from "@/components/overlay/store/getters";
import { actions } from "@/components/overlay/store/actions";
import { OverlayState } from "@/components/overlay/types";

export const state: OverlayState = {
  OverlayOpen: "",
  channelEpg: [],
  activeEpgItem: {
    id: 0,
    title: "",
    epgEndtime: "dayjs()",
    epgStarttime: "dayjs()",
    channel_id: 0,
    description: "",
    image: ""
  },
  activeVodItem: null,
  activeVodItemDuration: null,
  activeVodItemProgressDuration: null,
  tvShowMeta: null,
  activeTranslation: null,
  activeTranslationId: null
};

export const overlay: Module<OverlayState, RootState> = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
